export default __webpack_public_path__ + "static/media/set-pwd-email.5fbfbfc1.jpg";